import BenefitsFormContainer from './benefits_form_container';

const BenefitsForm = BenefitsFormContainer;
export default BenefitsForm;
